"use strict";
void 0 === window.HI && (window.HI = {}), HI.optInCookies = {
    allowed: function() {
        return document.cookie.match(/eu-opt-in=1/)
    },
    findReadMore: function() {
        if (!HI.optInCookies.readMoreURL)
            for (var e = document.getElementsByTagName("script"), o = 0; o < e.length; o++) e.item(o).getAttribute("read_more") && (HI.optInCookies.readMoreURL = e.item(o).getAttribute("read_more"));
        return HI.optInCookies.readMoreURL
    },
    hideQuery: function() {
        var e = document.getElementById("hi-cookie-box");
        e && e.parentNode.removeChild(e)
    },
    l10n: {
        agree: "Accept",
        agreeCaption: "Yes, I accept",
        queryBody: "To optimise your experience, we store information on your computer. By continuing your journey throughout the store, you consent to this.",
        queryTitle: "Cookie Policy",
        readMore: "Read more"
    },
    readMoreURL: void 0,
    showQuery: function() {
        var e = HI.optInCookies.topElement;
        if (!document.getElementById("hi-cookie-box")) {
            var o = document.createElement("div");
            o.id = "hi-cookie-box";
            var t = document.createElement("p");
            t.className = "hi-cookie-head", t.appendChild(document.createTextNode(HI.optInCookies.l10n.queryTitle)), o.appendChild(t);
            var n = document.createElement("p");
            n.className = "hi-cookie-intro";
            for (var i = HI.optInCookies.l10n.queryBody.split(/\n/), a = 0; a < i.length; a++) 0 < a && n.appendChild(document.createElement("br")), n.appendChild(document.createTextNode(i[a]));
            o.appendChild(n);
            var d = HI.optInCookies.findReadMore();
            if (d) {
           var r = document.createElement("a");
         r.className = "read-more", r.target = "/pages/cookie-policy", r.href = d, r.appendChild(document.createTextNode(HI.optInCookies.l10n.readMore));
                var p = document.createElement("br");
                n.appendChild(p), n.appendChild(p.cloneNode(!1)), n.appendChild(r)
            }
          var l = document.createElement("div");
            l.className = "hi-cookie-btn agree", l.title = HI.optInCookies.l10n.agreeCaption, l.appendChild(document.createTextNode(HI.optInCookies.l10n.agree)), l.onclick = function() {
                var e = new Date;
                e.setFullYear(e.getFullYear() + 5), document.cookie = "eu-opt-in=1; path=/; expires=" + e.toUTCString(), HI.optInCookies.showSplash(), HI.optInCookies.onAgree && HI.optInCookies.onAgree()
            }, o.appendChild(l);
            
            var m = document.createElement("div");
            m.style.clear = "both", o.appendChild(m), e.appendChild(o)
        }
    },
    showSplash: function() {
        var e;
        HI.optInCookies.topElement && (e = HI.optInCookies.topElement).parentNode.removeChild(e);
        if ((e = document.createElement("div")).id = "hi-eu-opt-in", document.body.appendChild(e), HI.optInCookies.topElement = e, HI.optInCookies.allowed()) {
            (o = document.createElement("div")).className = "opt-in-splash confirmed", e.appendChild(o)
        } else {
            var o;
            (o = document.createElement("div")).className = "opt-in-splash unconfirmed", o.onclick = HI.optInCookies.showQuery, e.appendChild(o), setTimeout(HI.optInCookies.showQuery, 500);
            var t = document.getElementById("hi-eu-opt-in");
            t.className = t.className + "active"
        }
    },
    topElement: ""
};